export default __webpack_public_path__ + "static/media/frame2.1e21ba32.png";